import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Actions as articleActions } from "../../core/redux/ducks/article";
import { Droppable } from "react-beautiful-dnd";
import { Container, EditorBodyContainer } from "./style/styledComponents";
import { debounce } from "lodash";
import JoditEditor from "jodit-react";
import "./style/style.css";

const ArticleEditor = ({ editorRef, editorContent, setContent }) => {
  const dispatch = useDispatch();
  const articleState = useSelector((state) => state.article);
  const { article } = articleState;

  const saveEditor = (editor, articleId) =>
    articleActions.saveEditor(dispatch, editor, articleId);
  const setStatus = () => dispatch(articleActions.setStatus("saved"));

  const autoSave = debounce((newContent) => {
    if (newContent && newContent !== article.editor.content) {
      const editor = {
        content: newContent,
      };
      console.log(newContent);
      // setContent(newContent);
      saveEditor({ ...article.editor, ...editor }, article.id);
    }
  }, 3000);

  useEffect(() => {
    console.log(editorContent);
    if (editorContent) {
      const newContent = editorRef.current.value + editorContent;
      editorRef.current.value = newContent;
      autoSave(newContent);
      setContent("");
    }
  }, [editorContent, editorRef]);

  return (
    <Container>
      <Droppable droppableId={"column-editor"} key={"column-editor"}>
        {(provided) => (
          <EditorBodyContainer
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <JoditEditor
              ref={editorRef}
              value={article.editor.content}
              config={{
                readonly: false,
                resize: true,
                minHeight: "540px",
                style: {
                  border: "none",
                },
              }}
              tabIndex={1} // tabIndex of textarea
              onChange={(newContent) => autoSave(newContent)} // preferred to use only this option to update the content for performance reasons
              // onChange={(e) => handleChange(e.target.innerHTML)}
              onBlur={setStatus}
            />
            {provided.placeholder}
          </EditorBodyContainer>
        )}
      </Droppable>
    </Container>
  );
};

export default ArticleEditor;
